<template>
  <div class="body">
    <div class="row">
      <div class="col-12">
        <div class="card p-4">
          <div style="margin-left: 10px">
            <p class="title-main">Casos tratados</p>
            <p class="description">
              Casos tratados independente do mês que a pesquisa entrou.
            </p>

            <div style="display: flex">
              <div style="display: grid; margin-right: 30px">
                <label>{{ $t('reports.treatmentMonitoring.profile') }}:</label>
                <b-form-select
                  class="mb-4"
                  style="width: 170px"
                  v-model="selectedProfile"
                  :options="optionsProfiles"
                ></b-form-select>
              </div>

              <div style="display: grid; margin-right: 30px">
                <label>Operador:</label>
                <b-form-select
                  class="mb-4"
                  style="width: 170px"
                  v-model="optionOperator"
                  :options="optionsOperators"
                ></b-form-select>
              </div>

              <div style="display: grid; margin-right: 30px">
                <label>Modo de tratativas:</label>
                <b-form-select
                  class="mb-4"
                  style="width: 170px"
                  v-model="optionModeTreatment"
                  :options="optionsTreatments"
                ></b-form-select>
              </div>
            </div>
          </div>

          <div v-if="loading" class="row align-center">
            <div class="col-6" style="margin: -5px">
              <div class="height-content border-card">
                <div class="display-flex">
                  <span class="title-card">{{
                    $t('reports.treatmentMonitoring.averageTreatment')
                  }}</span>
                  <span class="header-icon" id="popover-target-1"
                    ><font-awesome-icon :icon="['fas', 'info-circle']"
                  /></span>
                </div>

                <div class="container-hour">
                  <font-awesome-icon class="icon" :icon="['fas', 'clock']" />
                  <span class="hours">{{
                    averageTime.average ? averageTime.average.averageValue : 0
                  }}</span>
                </div>

                <b-popover
                  target="popover-target-1"
                  triggers="hover"
                  placement="top"
                >
                  <template #title>{{
                    $t('reports.treatmentMonitoring.averageTreatment')
                  }}</template>
                  {{ $t('reports.treatmentMonitoring.averageTreatmentDesc') }}
                </b-popover>

                <div class="display-flex">
                  <span class="total-period">Total no último período:</span>
                  <span class="number">{{
                    averageTime.average ? averageTime.average.total : 0
                  }}</span>
                </div>
              </div>
            </div>
            <div class="col-6" style="margin: -5px">
              <div class="height-content border-card">
                <div class="display-flex">
                  <span class="title-card">{{
                    $t('reports.treatmentMonitoring.averageAnswer')
                  }}</span>
                  <span class="header-icon" id="popover-target-3"
                    ><font-awesome-icon :icon="['fas', 'info-circle']"
                  /></span>
                </div>

                <b-popover
                  target="popover-target-3"
                  triggers="hover"
                  placement="top"
                >
                  <template #title>{{
                    $t('reports.treatmentMonitoring.averageAnswer')
                  }}</template>
                  {{ $t('reports.treatmentMonitoring.averageAnswerDesc') }}
                </b-popover>

                <div class="container-hour">
                  <font-awesome-icon
                    class="icon"
                    :icon="['fas', 'hourglass']"
                  />
                  <span class="hours"
                    >{{
                      averageTime.answerTimeAverage
                        ? averageTime.answerTimeAverage
                        : 0
                    }}
                    {{ $t('reports.treatmentMonitoring.hours') }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="text-center" v-else>
            <b-spinner
              variant="success"
              type="grow"
              label="Spinning"
              class="bg-primary"
            ></b-spinner>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card mt-3 height">
          <div style="padding-right: 0">
            <div class="pt-2">
              <b-button
                class="btn title btn-style"
                @click="viewType = 'operator'"
                :style="{
                  borderBottom:
                    viewType === 'operator' ? '2px solid #4DE594' : 'none',
                  color: viewType === 'operator' ? '#4DE594' : '',
                }"
                >{{
                  $t('reports.treatmentMonitoring.operatorStatus')
                }}</b-button
              >

              <b-button
                class="btn title btn-style"
                @click="viewType = 'contact'"
                :style="{
                  borderBottom:
                    viewType === 'contact' ? '2px solid #4DE594' : 'none',
                  color: viewType === 'contact' ? '#4DE594' : '',
                }"
                >Status do contato</b-button
              >
            </div>
          </div>

          <div style="border-bottom: solid 2px #f1f1f1"></div>

          <div
            v-show="loading && viewType === 'operator'"
            class="p-4"
            style="height: 360px; overflow: auto"
          >
            <b-table
              id="table-operator"
              :items="itemsTable"
              :fields="fields"
              style="font-size: 12px"
              responsive
              sort-icon-left
              striped
            ></b-table>
          </div>

          <div
            v-show="loading && viewType === 'contact'"
            class="p-4"
            style="height: 360px; overflow: auto"
          >
            <b-table
              id="table-contact"
              :items="itemsContact"
              :fields="fieldsContact"
              style="font-size: 12px"
              responsive
              sort-icon-left
              caption-bottom
            >
              <template v-slot:cell(allStatus)="row">
                <router-link
                  class="link"
                  :to="{
                    path: `treatments?monitoringreport=true&laststatus=${row.item.allStatus}`,
                  }"
                  >{{ row.item.allStatus }}</router-link
                >
              </template>
              <template v-slot:cell(progress)="row">
                <b-progress
                  style="width: 300px"
                  :value="row.item.progress"
                  variant="info"
                ></b-progress>
              </template>
            </b-table>
          </div>

          <div class="text-center" v-if="!loading">
            <b-spinner
              variant="success"
              type="grow"
              label="Spinning"
              class="bg-primary"
            ></b-spinner>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card mt-3 height-graph">
          <div class="row">
            <div class="col-6 pt-3">
              <b-button class="btn title btn-style">Status de perfil</b-button>
            </div>
            <div class="col-6" style="display: flex; justify-content: end">
              <div>
                <b-form-checkbox
                  v-model="checkedPerfil"
                  name="check-button"
                  class="mt-3 ml-4 mr-4"
                  switch
                >
                  <span class="view-perfil">Visualizar por perfil</span>
                </b-form-checkbox>
              </div>

              <div class="mr-4" style="margin-top: 15px">
                <b-form-select
                  class="col-2"
                  style="width: 180px; height: 36px"
                  v-model="selected"
                  :options="options"
                ></b-form-select>
              </div>
            </div>
          </div>

          <div style="border-bottom: solid 2px #f1f1f1"></div>

          <div style="display: flex">
            <div class="col-3 ml-3 mt-3 mb-3">
              <p class="media-period mb-2">
                {{ $t('reports.treatmentMonitoring.averagePeriod') }}
              </p>
              <template v-if="loadingGraphColumn">
                <span class="number-period">{{ averagePeriod }}</span></template
              ><template class="text-center" v-else>
                <b-spinner
                  variant="success"
                  type="grow"
                  label="Spinning"
                  class="bg-primary"
                ></b-spinner>
              </template>
            </div>
          </div>

          <div
            style="
              border-bottom: solid 2px #f1f1f1;
              margin-right: 20px;
              margin-left: 20px;
            "
          ></div>
          <highcharts
            v-show="loadingGraphColumn && !checkedPerfil"
            class="mt-3"
            :options="chartOptionsColumn"
          ></highcharts>
          <highcharts
            v-show="loadingGraphColumn && checkedPerfil"
            class="mt-3"
            :options="chartOptionsStack"
          ></highcharts>
          <div class="text-center" v-if="!loading">
            <b-spinner
              variant="success"
              type="grow"
              label="Spinning"
              class="bg-primary"
            ></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import api from '../../../../services/api';

export default {
  data() {
    return {
      selected: 'month',
      loading: false,
      selectedProfile: 'all',
      options: [
        { value: null, text: 'Selecione' },
        { value: 'day', text: 'Diário' },
        { value: 'month', text: 'Mensal' },
        { value: 'week', text: 'Semanal' },
        { value: 'quarter', text: 'Trimestral' },
      ],
      chartOptionsPie: {
        chart: {
          type: 'pie',
          height: '350px',
        },
        title: {
          text: '',
        },
        plotOptions: {
          series: {
            innerSize: '60%',
            dataLabels: {
              enabled: false,
              format: '{point.percentage:.1f}%',
            },
            showInLegend: true,
          },
        },
        colors: [
          '#dc3545',
          '#72bcd4',
          '#ffc107',
          '#28a745',
          '#37E688',
          '#000080',
          '#FCBE30',
          '#FF00FF',
          '#e0d1ed',
          '#f0b9cf',
          '#e63c80',
          '#c70452',
          '#4b004c',
          '#cfb698',
          '#ff5d57',
          '#91c68d',
          '#796c86',
          '#ece488',
          '#938172',
        ],
        series: [
          {
            name: 'Status',
            colorByPoint: true,
            data: [],
          },
        ],
      },
      chartOptionsPieChannel: {
        chart: {
          type: 'pie',
          height: '350px',
        },
        title: {
          text: '',
        },
        plotOptions: {
          series: {
            innerSize: '60%',
            dataLabels: {
              enabled: false,
              format: '{point.percentage:.1f}%',
            },
            showInLegend: true,
          },
        },
        colors: [
          '#19AEB3',
          '#72bcd4',
          '#37E688',
          '#191970',
          '#4169E1',
          '#6959CD',
          '#836FFF',
          '#000080',
          '#0000CD',
          '#6495ED',
          '#1E90FF',
        ],
        series: [
          {
            name: 'Status',
            colorByPoint: true,
          },
        ],
      },
      itemsTable: [],
      fields: [],
      chartOptionsColumn: {
        chart: {
          type: 'column',
          height: '380px',
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        xAxis: {
          title: {
            text: '',
          },
          categories: [],
        },
        yAxis: {
          title: {
            text: 'Quantidade',
          },
        },
        tooltip: {
          shared: true,
          headerFormat: '<b>Tratativas individuais</b><br></p><br>',
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            },
          },
        },
        colors: ['#37E688'],
        series: [],
      },
      chartOptionStack: {
        chart: {
          type: 'column',
          height: '380px',
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        xAxis: {
          title: {
            text: '',
          },
          categories: [],
        },
        yAxis: {
          title: {
            text: 'Quantidade',
          },
        },
        tooltip: {
          shared: true,
          headerFormat: '<b>Tratativas individuais</b><br></p><br>',
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            },
          },
        },
        colors: ['#527BF2', '#19AEB3'],
        series: [],
      },
      optionsProfiles: [
        { value: null, text: 'Selecione' },
        { value: 'all', text: 'Todos' },
        { value: 'promoters', text: 'Promotor' },
        { value: 'passives', text: 'Neutro' },
        { value: 'detractors', text: 'Detrator' },
      ],
      chartOptionsStack: {
        chart: {
          type: 'column',
          height: '380px',
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        xAxis: {
          title: {
            text: '',
          },
          categories: [],
        },
        yAxis: {
          title: {
            text: 'Quantidade',
          },
        },
        tooltip: {
          shared: true,
          headerFormat: '<b>Tratativas individuais</b><br></p><br>',
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            stacking: 'normal',
            dataLabels: {
              enabled: true,
            },
          },
        },
        colors: ['#37E688', '#F2D116', '#FF513D'],
        series: [],
      },
      optionOperator: 'all',
      optionModeTreatment: 'individual',
      optionsOperators: [],
      userAuth: null,
      averageTime: null,
      averagePeriod: 0,
      loadingGraphColumn: false,
      viewType: 'operator',
      viewTypePie: 'actual',
      viewTypeGraph: 'treatment',
      viewTypeCase: 'newCase',
      itemsContact: [],
      fieldsContact: [
        {
          key: 'allStatus',
          label: 'Todos os status',
          class: 'questionTh',
          sortable: true,
        },
        { key: 'progress', class: 'progressTh', label: '' },
        { key: 'percentil', label: '%' },
        { key: 'total', label: 'Total', sortable: true, class: 'totalTh' },
      ],
      checkedPerfil: false,
      optionsTreatments: [
        { value: null, text: 'Selecione' },
        { value: 'all', text: 'Todos' },
        { value: 'individual', text: 'Individuais' },
        { value: 'largeScale', text: 'Em massa' },
      ],
    };
  },

  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
    ...mapState('settings', ['companyAllUsers']),
  },

  methods: {
    ...mapActions('settings', ['getAllUsers']),

    async getDataCards() {
      this.loading = false;

      const response = await api.get('/reports/treatment-monitor/averages', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          profile: this.selectedProfile,
          operator: this.optionOperator,
          treatment: this.optionModeTreatment,
          reportCaseType: 'treatedCases',
        },
      });

      this.averageTime = response.data.treatmentAverages;

      this.loading = true;
    },

    async getDataPie() {
      const response = await api.get(
        '/reports/treatment-monitor/current-status',
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
            startDate: this.calendarDates.start,
            endDate: this.calendarDates.end,
            ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
            ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
            metric: this.myMetric,
            groupId: this.actionGroupData._id,
            indicator: this.indicatorName,
            indicatorValue: this.indicatorData.value,
            indicatorRange: this.indicatorData.range,
            profile: this.selectedProfile,
            operator: this.optionOperator,
            treatment: this.optionModeTreatment,
            reportCaseType: 'treatedCases',
          },
        },
      );

      this.chartOptionsPie.series[0].data = response.data.currentStatus;
      this.chartOptionsPieChannel.series[0].data =
        response.data.currentStatusByChannel;
    },

    async getDataTable() {
      const response = await api.get(
        '/reports/treatment-monitor/by-responsible',
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
            startDate: this.calendarDates.start,
            endDate: this.calendarDates.end,
            ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
            ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
            metric: this.myMetric,
            groupId: this.actionGroupData._id,
            indicator: this.indicatorName,
            indicatorValue: this.indicatorData.value,
            indicatorRange: this.indicatorData.range,
            profile: this.selectedProfile,
            operator: this.optionOperator,
            treatment: this.optionModeTreatment,
            reportCaseType: 'treatedCases',
          },
        },
      );

      const data = response.data;

      this.itemsContact = data.statusByContact;
      this.itemsTable = data.statusByResponsible;
      this.fields = data.fields;
    },

    async getDataChartColumn() {
      this.loadingGraphColumn = false;

      const response = await api.get('/reports/treatment-monitor/by-period', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          profile: this.selectedProfile,
          reportType: this.selected,
          viewByPerfil: this.checkedPerfil,
          operator: this.optionOperator,
          treatment: this.optionModeTreatment,
          reportCaseType: 'treatedCases',
        },
      });

      const data = response.data;

      this.chartOptionsColumn.series = data.series.profile;
      this.chartOptionsColumn.xAxis.categories = data.categories;
      this.averagePeriod = data.average;

      this.chartOptionStack.series = data.series.treatment;
      this.chartOptionStack.xAxis.categories = data.categories;

      this.loadingGraphColumn = true;
    },

    async getDataViewByProfile() {
      const response = await api.get('/reports/treatment-monitor/by-profile', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          profile: this.selectedProfile,
          reportType: this.selected,
          viewByPerfil: this.checkedPerfil,
          operator: this.optionOperator,
          treatment: this.optionModeTreatment,
          reportCaseType: 'treatedCases',
        },
      });

      if (response.data.series) {
        this.chartOptionsStack.series = response.data.series[0].data;
        this.chartOptionsStack.xAxis.categories = response.data.categories;
      }
    },
  },

  watch: {
    optionOperator: function watchOperator() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
    },

    checkedPerfil: async function watchCheckedPerfil() {
      const response = await api.get('/reports/treatment-monitor/by-profile', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          profile: this.selectedProfile,
          reportType: this.selected,
          viewByPerfil: this.checkedPerfil,
          operator: this.optionOperator,
          treatment: this.optionModeTreatment,
          reportCaseType: 'treatedCases',
        },
      });

      if (response.data.series) {
        this.chartOptionsStack.series = response.data.series[0].data;
        this.chartOptionsStack.xAxis.categories = response.data.categories;
      }
    },

    calendarDates: function watchCalendarDates() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    myActionId: function watchMyActionId() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    actionGroupData: function watchActionGroup() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    myIh1: function watchMyIh1() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    myHierarchies1: function watchMyHierarchies1() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    myIh2: function watchMyIh2() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    myHierarchies2: function watchMyHierarchies2() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    myMetric: function watchMyMetric() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    'indicatorData.value': function watchIndicatorData() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    'indicatorData.period': function watchIndicatorPeriod() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    selectedProfile: function watchProfile() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },

    selected: function filterPeriod() {
      this.getDataCards();
      this.getDataPie();
      this.getDataTable();
      this.getDataChartColumn();
      this.getDataViewByProfile();
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    await this.getAllUsers({
      userId: this.userAuth._id,
      companyId: this.userAuth.companyId,
      token: this.userAuth.token,
    });

    const allUsers = this.companyAllUsers;

    for (let i = 0; i < allUsers.length; i += 1) {
      if (allUsers[i].text === 'Ninguém') {
        allUsers.splice(i, 1);
      }
    }

    if (this.userAuth.profileId === '64247cb121703c001a49e72a' || this.userAuth.profileId === '5e74d204495c4f4c08aadf36' ||
    this.userAuth.profileId === '5e74d116495c4f4c08aadf34'
    ) {
      allUsers.unshift({
        text: 'Todos',
        value: 'all',
      });

      this.optionsOperators = allUsers;
    } else {
      this.optionsOperators = [{
        text: this.userAuth.name,
        value: this.userAuth._id
      }];
      this.optionOperator = this.userAuth._id;
    }

    await this.getDataCards();
    await this.getDataPie();
    await this.getDataTable();
    await this.getDataChartColumn();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.description {
  color: #808080;
  font-weight: 600;
  font-size: 16px;
  line-height: 12px;
}

.link {
  color: #5299f2;
}

.view-perfil {
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  color: black;
}

.btn-style {
  width: 30%;
  border-radius: 0;
  border: none;
  background: transparent;
  // padding: 15px;
}

.card-body {
  padding: 0;
}

.btn:focus {
  outline: none;
  box-shadow: none;
}

.btn {
  box-shadow: none !important;
}

.header-icon {
  color: $gray;
}

.title {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #242424;
  text-align: center;
  padding-bottom: 15px;
}

.title-card {
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #242424;
  text-transform: uppercase;
}

.align-center {
  align-items: center;
  justify-content: center;
}

.height-content {
  height: 140px;
}

.col-2 {
  width: 220px !important;
  max-width: 220px !important;
  flex: auto !important;
}

.border-card {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  margin: -2px;
  padding: 15px;
  margin-left: 5px;
}

.hours {
  font-weight: 700;
  font-size: 18px;
  line-height: 12px;
  color: #242424;
}

.icon {
  color: #4de594;
  width: 28px;
  height: 18px;
}

.container-hour {
  padding-bottom: 10px;
  padding-top: 10px;
}

.number {
  font-weight: 700;
  color: #5f6368;
  font-size: 14px;
  margin-left: 2px;
}

.total-period {
  color: #5f6368;
  font-weight: 300;
  font-size: 14px;
  line-height: 12px;
}

.display-flex {
  display: flex;
  align-items: center;
}

.line {
  background: #f1f1f1;
  margin-left: -11px;
  margin-right: -11px;
  margin-top: 18px;
  height: 28px;
}

.title-main {
  font-weight: 600;
  font-size: 24px;
  line-height: 12px;
  color: #242424;
}

.body {
  background: #e6e6e6;
  padding: 16px;
}

.height {
  min-height: 450px;
  height: 450px;
}

.height-graph {
  min-height: 550px;
  height: 550px;
}

.media-period {
  font-weight: 600;
  font-size: 14px;
  line-height: 12px;
  color: #979797;
}

.number-period {
  font-weight: 700;
  font-size: 24px;
  line-height: 12px;
  color: #242424;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/monitoring-treatment/treated-cases.vue